/* eslint-env browser */

'use strict';

var Multiselect = require('./Multiselect');

/**
 * Netx tag editor
 * @constructor
 * @extends Multiselect
 */
var Tag = Multiselect.extend('Tag', {
	/**
	 * @memberof Tag.prototype
	 * @desc everything is selected
	 * @override Multiselect.prototype
	 */
	template: [
		'<div class="container" style="position:relative">',
			'<select id="editor" multiple="multiple">',
				'{{#items}}',
					'<option value="{{.}}" selected="selected">{{.}}</option>',
				'{{/items}}',
			'</select>',
		'</div>'
	].join('\n'),

	/**
	 * @memeberof Tag.prototype
	 * @desc cleanup select2 plugin
	 */
	cleanupSelect2: function() {
		if (typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.select2 !== 'undefined' && window.jQuery(this.input).data('select2')) {
			window.jQuery(this.input).select2('destroy');
		}
	},

	/**
	 * @memberof Tag.prototype
	 * @desc cleanup select and hide editor
	 * @override Multiselect.prototype
	 */
	hideEditor: function() {
		// Hide
		this.el.style.display = 'none';
		this.cleanupSelect2();
	},

	/**
	 * @memberof Tag.prototype
	 * @override Multiselect.prototype
	 * @param {mixed} value
	 * @param {boolean} fromInactiveState
	 */
	setEditorValue: function(value, fromInactiveState) {
		if (fromInactiveState) {
			this.toSet = value;
			return;
		}
		// We need to break it up into an array if not already
		// if (value && !Array.isArray(value)) {
		// 	value = value.split(/\,\s{0,1}/);
		// }
	},

	/**
	 * @memberof Tag.prototype
	 * @desc show editor and initialize select2
	 * @override Multiselect.prototype
	 */
	showEditor: function() {
		var self        = this,
			columnProps = this.event.columnProperties;

		setTimeout(function() {
			var jQuery = typeof window.jQuery !== 'undefined' && window.jQuery;
			if (!jQuery || typeof window.jQuery.fn.select2 === 'undefined') {
				return;
			}
			// Show
			self.el.style.display = 'inline-block';
			if (columnProps.spec1) {
				// Get autcomplete plugin
				var autocomplete = window.Netx.autocomplete.get('tag', { plugin: 's2', datasetId: columnProps.spec1, multiple: true }, null);
				// Init select2
				autocomplete.options.width = '100%';
				jQuery(self.input).select2(autocomplete.options);
				jQuery(self.el).find('.select2-search__field').focus().val(self.toSet).trigger('keyup');
				delete self.toSet;
			} else {
				console.error('Spec1 not provided for tag attribute');
			}
		}, 50);
	}

});

module.exports = Tag;
